export enum CognitoUserGroup {
  CommunityManager = "community_manager",
  CommunityPortfolioExecutive = "community_portfolio_executive",
  CoverTreeEmployee = "ct_employee",
  CoverTreeExecutive = "ct_executive",
  Resident = "resident",
}

export default CognitoUserGroup;
